export default {

  ravenExists() {
    return typeof window.Raven !== 'undefined'
  },

  wrap(callback) {
    if (this.ravenExists()) {
      callback()
    } else {
      window.analytics.ready(() => {
        if (this.ravenExists()) {
          callback()
        }
      })
    }
  },

  setRelease(release) {
    this.wrap(() => window.Raven.setRelease(release))
  },

  setUserContext(user) {
    this.wrap(() => window.Raven.setUserContext(user))
  },

  captureException(error, extra) {
    this.wrap(() => window.Raven.captureException(error, { extra }))
  },

}



/** WEBPACK FOOTER **
 ** ./src/utils/raven/raven.js
 **/